// ============================================================================
// FILE: src/modules/ticket/components/performance/charts/SLATrendChart.jsx
// PURPOSE:
//   Honest SLA snapshot visualization (NOT fake trend)
// ============================================================================

import React from "react";

export default function SLATrendChart({ slaPct }) {
  if (slaPct === null || slaPct === undefined) {
    return null;
  }

  const value = Math.min(Math.max(Number(slaPct) || 0, 0), 100);

  return (
    <div
      style={{
        marginTop: 24,
        padding: 16,
        borderRadius: 12,
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
      }}
    >
      <h4 style={{ marginBottom: 8 }}>SLA Compliance (Current Period)</h4>

      <div
        style={{
          height: 10,
          width: "100%",
          background: "#e5e7eb",
          borderRadius: 6,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${value}%`,
            height: "100%",
            background: value >= 90 ? "#16a34a" : value >= 75 ? "#f59e0b" : "#dc2626",
          }}
        />
      </div>

      <div style={{ marginTop: 8, fontSize: 13 }}>
        <strong>{value.toFixed(1)}%</strong> SLA met for the selected period
      </div>

      <div style={{ marginTop: 6, fontSize: 12, color: "#6b7280" }}>
        Trend view will be enabled once sufficient historical data is available.
      </div>
    </div>
  );
}
